/* ==========================================================================
   Lalanka — Hediye Kutusu Oluşturucu
   Bağımlılık yok. Bölümün kendi kökü dışına hiç dokunmaz.

   İki mod var:
   - "same" : tek kutu kurulur, kurumsal modda seçilen adette çoğaltılır.
   - "each" : her kutu ayrı kurulur; içerik, alıcı adı ve kart notu kutuya özel.
   ========================================================================== */

(function () {
  'use strict';

  /** Shopify para biçimi (örn. "{{amount}}TL") uygulayıcısı. */
  function formatMoney(cents, format) {
    var value = (cents || 0) / 100;

    function thousands(number, decimals, thousandSep, decimalSep) {
      var fixed = number.toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandSep);
      return parts[1] ? whole + decimalSep + parts[1] : whole;
    }

    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, token) {
      switch (token) {
        case 'amount_no_decimals':
          return thousands(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return thousands(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return thousands(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return thousands(value, 2, "'", '.');
        default:
          return thousands(value, 2, ',', '.');
      }
    });
  }

  function boxCode() {
    var chars = 'ABCDEFGHJKLMNPRSTUVYZ23456789';
    var out = '';
    for (var i = 0; i < 4; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
    return out;
  }

  /** Kullanıcı metni innerHTML'e girdiği için kaçışlanır. */
  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function newBox() {
    return { sel: new Map(), to: '', msg: '' };
  }

  /**
   * Sepetten elle silinen kutuların kart notları sepet özniteliğinde kalıyor;
   * artık karşılığı olmayan kayıtları boş değerle temizler (Shopify boş değeri siler).
   */
  function staleAttributes(cart, keepCode) {
    var live = {};
    var stale = {};
    if (keepCode) live[keepCode] = true;
    (cart.items || []).forEach(function (item) {
      var code = item.properties && item.properties['Hediye Kutusu'];
      if (code) live[String(code).split('/')[0]] = true;
    });
    Object.keys(cart.attributes || {}).forEach(function (key) {
      if (!/^(Hediye|Kutu)\b/.test(key)) return;
      var match = key.match(/\b([A-Z0-9]{4})(?:\/\d+)?\b/);
      if (match && !live[match[1]]) stale[key] = '';
    });
    return stale;
  }

  function GiftBuilder(root) {
    this.root = root;
    this.moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    this.cartAddUrl = (window.routes && window.routes.cart_add_url) || root.dataset.cartAdd || '/cart/add';
    this.cartUrl = (window.routes && window.routes.cart_url) || root.dataset.cartUrl || '/cart';

    this.boxes = [newBox()];
    this.state = {
      step: 1,
      occasion: '',
      size: parseInt(root.dataset.defaultSize, 10) || 5,
      free: false,
      boxCount: 1,
      mode: 'same',
      active: 0,
      ribbon: '',
      ribbonName: '',
      filterCat: 'all',
      filterScent: 'all'
    };

    this.el = {
      steps: root.querySelectorAll('[data-gb-step-item]'),
      panels: root.querySelectorAll('[data-gb-panel]'),
      corp: root.querySelector('[data-gb-corp]'),
      boxesInput: root.querySelector('[data-gb-boxes]'),
      corpHint: root.querySelector('[data-gb-corp-hint]'),
      modeRow: root.querySelector('[data-gb-mode-row]'),
      boxTabs: root.querySelector('[data-gb-boxtabs]'),
      copyPrev: root.querySelector('[data-gb-copyprev]'),
      cardFor: root.querySelector('[data-gb-cardfor]'),
      items: Array.prototype.slice.call(root.querySelectorAll('[data-gb-item]')),
      empty: root.querySelector('[data-gb-empty]'),
      slots: root.querySelector('[data-gb-slots]'),
      lines: root.querySelector('[data-gb-lines]'),
      countLabel: root.querySelector('[data-gb-count-label]'),
      subtotal: root.querySelector('[data-gb-subtotal]'),
      subtotalLabel: root.querySelector('[data-gb-subtotal-label]'),
      total: root.querySelector('[data-gb-total]'),
      boxesRow: root.querySelector('[data-gb-boxes-row]'),
      boxesCount: root.querySelector('[data-gb-boxes-count]'),
      note: root.querySelector('[data-gb-note]'),
      submit: root.querySelector('[data-gb-submit]'),
      side: root.querySelector('[data-gb-side]'),
      barLabel: root.querySelector('[data-gb-bar-label]'),
      barTotal: root.querySelector('[data-gb-bar-total]'),
      done: root.querySelector('[data-gb-done]'),
      builder: root.querySelector('[data-gb-builder]'),
      error: root.querySelector('[data-gb-error]'),
      msg: root.querySelector('[data-gb-msg]'),
      msgCount: root.querySelector('[data-gb-msg-count]'),
      to: root.querySelector('[data-gb-to]'),
      from: root.querySelector('[data-gb-from]'),
      date: root.querySelector('[data-gb-date]'),
      prevTo: root.querySelector('[data-gb-preview-to]'),
      prevMsg: root.querySelector('[data-gb-preview-msg]'),
      prevFrom: root.querySelector('[data-gb-preview-from]')
    };

    this.bind();
    root.classList.add('gb--js');
    this.goTo(1);
    this.render();
  }

  /* --- Kutu yardımcıları --------------------------------------------------- */

  GiftBuilder.prototype.current = function () {
    return this.boxes[this.state.active] || this.boxes[0];
  };

  /** Sepete gidecek kutu sayısı. */
  GiftBuilder.prototype.liveCount = function () {
    return this.state.mode === 'each' ? Math.max(1, this.state.boxCount) : 1;
  };

  GiftBuilder.prototype.ensureBoxes = function () {
    // Kutu sayısı azaltılırsa veriyi silmiyoruz; tekrar artırılırsa geri gelir.
    while (this.boxes.length < Math.max(1, this.state.boxCount)) this.boxes.push(newBox());
    if (this.state.active >= this.liveCount()) this.state.active = this.liveCount() - 1;
  };

  GiftBuilder.prototype.limit = function () {
    return this.state.free ? 0 : this.state.size;
  };

  GiftBuilder.prototype.boxItems = function (box) {
    var total = 0;
    box.sel.forEach(function (item) {
      total += item.qty;
    });
    return total;
  };

  GiftBuilder.prototype.boxSubtotal = function (box) {
    var total = 0;
    box.sel.forEach(function (item) {
      total += item.qty * item.price;
    });
    return total;
  };

  GiftBuilder.prototype.boxReady = function (box) {
    var limit = this.limit();
    var n = this.boxItems(box);
    return limit ? n === limit : n >= 2;
  };

  GiftBuilder.prototype.grandTotal = function () {
    var self = this;
    if (this.state.mode === 'each') {
      var sum = 0;
      for (var i = 0; i < this.liveCount(); i++) sum += self.boxSubtotal(self.boxes[i]);
      return sum;
    }
    return this.boxSubtotal(this.boxes[0]) * Math.max(1, this.state.boxCount);
  };

  GiftBuilder.prototype.allReady = function () {
    if (this.state.mode === 'each') {
      for (var i = 0; i < this.liveCount(); i++) {
        if (!this.boxReady(this.boxes[i])) return false;
      }
      return true;
    }
    return this.boxReady(this.boxes[0]);
  };

  /* --- Olaylar ------------------------------------------------------------- */

  GiftBuilder.prototype.bind = function () {
    var self = this;
    var root = this.root;

    root.addEventListener('click', function (event) {
      var step = event.target.closest('[data-gb-step-to]');
      if (step) {
        event.preventDefault();
        self.goTo(parseInt(step.dataset.gbStepTo, 10));
        return;
      }
      if (event.target.closest('[data-gb-next]')) {
        event.preventDefault();
        self.goTo(self.state.step + 1);
        return;
      }
      if (event.target.closest('[data-gb-back]')) {
        event.preventDefault();
        self.goTo(self.state.step - 1);
        return;
      }
      if (event.target.closest('[data-gb-autofill]')) {
        event.preventDefault();
        self.autofill();
        return;
      }
      if (event.target.closest('[data-gb-copyprev]')) {
        event.preventDefault();
        self.copyPrevious();
        return;
      }
      if (event.target.closest('[data-gb-restart]')) {
        event.preventDefault();
        self.restart();
        return;
      }

      var tab = event.target.closest('[data-gb-box]');
      if (tab) {
        event.preventDefault();
        self.switchBox(parseInt(tab.dataset.gbBox, 10));
        return;
      }

      var chip = event.target.closest('[data-gb-filter]');
      if (chip) {
        event.preventDefault();
        self.setFilter(chip);
        return;
      }

      var add = event.target.closest('[data-gb-add]');
      if (add) {
        event.preventDefault();
        self.change(add.closest('[data-gb-item]'), 1);
        return;
      }
      var plus = event.target.closest('[data-gb-plus]');
      if (plus) {
        event.preventDefault();
        self.change(plus.closest('[data-gb-item]'), 1);
        return;
      }
      var minus = event.target.closest('[data-gb-minus]');
      if (minus) {
        event.preventDefault();
        self.change(minus.closest('[data-gb-item]'), -1);
        return;
      }
      var remove = event.target.closest('[data-gb-remove]');
      if (remove) {
        event.preventDefault();
        self.removeId(remove.dataset.gbRemove);
        return;
      }
      if (event.target.closest('[data-gb-bar]')) {
        event.preventDefault();
        self.el.side.classList.toggle('is-open');
        return;
      }
      if (event.target.closest('[data-gb-submit]')) {
        event.preventDefault();
        self.submit();
      }
    });

    // Vesile
    root.querySelectorAll('[data-gb-occasion]').forEach(function (input) {
      input.addEventListener('change', function () {
        self.state.occasion = input.value;
        self.markSelected(input);
        var isCorporate = input.dataset.gbCorporate === 'true';
        if (self.el.corp) self.el.corp.hidden = !isCorporate;
        if (!isCorporate) {
          self.state.boxCount = 1;
          self.state.mode = 'same';
          self.state.active = 0;
          if (self.el.boxesInput) self.el.boxesInput.value = 1;
        }
        var suggestion = input.dataset.gbMessage;
        if (suggestion && self.el.msg && !self.el.msg.value.trim()) {
          self.el.msg.value = suggestion;
          self.current().msg = suggestion;
          self.updateCard();
        }
        self.render();
      });
    });

    // Kutu boyutu
    root.querySelectorAll('[data-gb-size]').forEach(function (input) {
      input.addEventListener('change', function () {
        self.markSelected(input);
        if (input.value === 'free') {
          self.state.free = true;
        } else {
          self.state.free = false;
          self.state.size = parseInt(input.value, 10);
        }
        self.render();
      });
    });

    // Aynı mı / farklı mı
    root.querySelectorAll('[data-gb-mode]').forEach(function (input) {
      input.addEventListener('change', function () {
        self.markSelected(input);
        self.saveCard();
        self.state.mode = input.value === 'each' ? 'each' : 'same';
        self.state.active = 0;
        self.ensureBoxes();
        self.loadCard();
        self.render();
      });
    });

    // Kurdele
    root.querySelectorAll('[data-gb-ribbon]').forEach(function (input) {
      input.addEventListener('change', function () {
        self.markSelected(input);
        self.state.ribbon = input.value;
        self.state.ribbonName = input.dataset.gbRibbonName || '';
        self.root.style.setProperty('--gb-ribbon-color', input.value);
      });
    });

    // Kutu adedi
    if (this.el.boxesInput) {
      this.el.boxesInput.addEventListener('input', function () {
        var value = parseInt(self.el.boxesInput.value, 10);
        self.state.boxCount = isNaN(value) || value < 1 ? 1 : value;
        self.ensureBoxes();
        self.render();
      });
    }

    // Varyant seçimi
    root.querySelectorAll('[data-gb-variant]').forEach(function (select) {
      select.addEventListener('change', function () {
        var item = select.closest('[data-gb-item]');
        var option = select.options[select.selectedIndex];
        var oldId = item.dataset.variant;
        self.boxes.forEach(function (box) {
          if (box.sel.has(oldId)) box.sel.delete(oldId);
        });
        item.dataset.variant = option.value;
        item.dataset.price = option.dataset.price;
        item.dataset.variantTitle = option.dataset.title || '';
        var priceEl = item.querySelector('[data-gb-item-price]');
        if (priceEl) priceEl.textContent = self.money(parseInt(option.dataset.price, 10));
        self.render();
      });
    });

    // Kart alanları — "kime" ve "not" aktif kutuya, "kimden" tüm kutulara ortak
    if (this.el.to) {
      this.el.to.addEventListener('input', function () {
        self.current().to = self.el.to.value;
        self.updateCard();
        self.renderTabs();
      });
    }
    if (this.el.msg) {
      this.el.msg.addEventListener('input', function () {
        self.current().msg = self.el.msg.value;
        self.updateCard();
      });
    }
    if (this.el.from) {
      this.el.from.addEventListener('input', function () {
        self.updateCard();
      });
    }

    this.updateCard();
  };

  GiftBuilder.prototype.money = function (cents) {
    return formatMoney(cents, this.moneyFormat);
  };

  GiftBuilder.prototype.markSelected = function (input) {
    var name = input.name;
    this.root.querySelectorAll('input[name="' + name + '"]').forEach(function (other) {
      var wrapper = other.closest('.gb-choice, .gb-ribbon');
      if (wrapper) wrapper.classList.toggle('is-selected', other.checked);
    });
  };

  /* --- Kutular arası geçiş ------------------------------------------------- */

  GiftBuilder.prototype.saveCard = function () {
    var box = this.current();
    if (!box) return;
    if (this.el.to) box.to = this.el.to.value;
    if (this.el.msg) box.msg = this.el.msg.value;
  };

  GiftBuilder.prototype.loadCard = function () {
    var box = this.current();
    if (!box) return;
    if (this.el.to) this.el.to.value = box.to || '';
    if (this.el.msg) this.el.msg.value = box.msg || '';
    this.updateCard();
  };

  GiftBuilder.prototype.switchBox = function (index) {
    if (isNaN(index) || index < 0 || index >= this.liveCount()) return;
    this.saveCard();
    this.state.active = index;
    this.loadCard();
    this.render();
  };

  GiftBuilder.prototype.copyPrevious = function () {
    var index = this.state.active;
    if (this.state.mode !== 'each' || index < 1) return;
    var source = this.boxes[index - 1];
    var target = this.current();
    target.sel = new Map();
    source.sel.forEach(function (item, id) {
      target.sel.set(id, {
        qty: item.qty,
        title: item.title,
        variantTitle: item.variantTitle,
        price: item.price,
        img: item.img,
        url: item.url
      });
    });
    this.render();
  };

  /* --- Adımlar ve filtreler ------------------------------------------------ */

  GiftBuilder.prototype.goTo = function (step) {
    var total = this.el.panels.length;
    if (step < 1) step = 1;
    if (step > total) step = total;
    this.state.step = step;

    this.el.panels.forEach(function (panel) {
      if (parseInt(panel.dataset.gbPanel, 10) === step) {
        panel.setAttribute('data-gb-active', '');
      } else {
        panel.removeAttribute('data-gb-active');
      }
    });

    this.el.steps.forEach(function (item) {
      var index = parseInt(item.dataset.gbStepItem, 10);
      item.classList.toggle('gb-steps__item--current', index === step);
      item.classList.toggle('gb-steps__item--done', index < step);
    });

    if (step > 1) {
      var top = this.root.getBoundingClientRect().top + window.pageYOffset - 20;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  };

  GiftBuilder.prototype.setFilter = function (chip) {
    var group = chip.dataset.gbFilter;
    var value = chip.dataset.gbValue;
    if (group === 'cat') this.state.filterCat = value;
    if (group === 'scent') this.state.filterScent = value;

    this.root.querySelectorAll('[data-gb-filter="' + group + '"]').forEach(function (other) {
      other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
    });

    this.applyFilters();
  };

  GiftBuilder.prototype.applyFilters = function () {
    var cat = this.state.filterCat;
    var scent = this.state.filterScent;
    var visible = 0;

    this.el.items.forEach(function (item) {
      var okCat = cat === 'all' || item.dataset.cat === cat;
      var okScent = scent === 'all' || item.dataset.scent === scent;
      var show = okCat && okScent;
      item.hidden = !show;
      if (show) visible++;
    });

    if (this.el.empty) this.el.empty.hidden = visible > 0;
  };

  /* --- Seçim --------------------------------------------------------------- */

  GiftBuilder.prototype.change = function (item, delta) {
    if (!item) return;
    var box = this.current();
    var id = item.dataset.variant;
    var limit = this.limit();
    var current = box.sel.get(id);

    if (delta > 0 && limit && this.boxItems(box) >= limit) {
      this.flash(
        'Kutun dolu — ' + limit + ' ürün seçtin. Daha fazlası için üstten daha büyük bir kutu seç.'
      );
      return;
    }

    if (delta > 0) {
      if (current) {
        current.qty += 1;
      } else {
        box.sel.set(id, {
          qty: 1,
          title: item.dataset.title || '',
          variantTitle: item.dataset.variantTitle || '',
          price: parseInt(item.dataset.price, 10) || 0,
          img: item.dataset.img || '',
          url: item.dataset.url || ''
        });
      }
    } else if (current) {
      current.qty -= 1;
      if (current.qty <= 0) box.sel.delete(id);
    }

    this.render();
  };

  GiftBuilder.prototype.removeId = function (id) {
    this.current().sel.delete(id);
    this.render();
  };

  GiftBuilder.prototype.autofill = function () {
    var self = this;
    var limit = this.limit() || 3;
    var pool = this.el.items.filter(function (item) {
      return !item.hidden;
    });

    // Kategoriler arasında dönerek dengeli bir seçim kur.
    var byCat = {};
    pool.forEach(function (item) {
      var key = item.dataset.cat || 'x';
      if (!byCat[key]) byCat[key] = [];
      byCat[key].push(item);
    });
    var keys = Object.keys(byCat);
    keys.forEach(function (key) {
      byCat[key].sort(function () {
        return Math.random() - 0.5;
      });
    });

    this.current().sel = new Map();
    var guard = 0;
    var index = 0;
    while (this.boxItems(this.current()) < limit && guard < 200) {
      var key = keys[index % keys.length];
      var next = byCat[key] && byCat[key].shift();
      if (next) self.change(next, 1);
      index++;
      guard++;
    }
    this.render();
  };

  GiftBuilder.prototype.flash = function (message) {
    if (!this.el.note) return;
    this.el.note.textContent = message;
    var self = this;
    clearTimeout(this.flashTimer);
    this.flashTimer = setTimeout(function () {
      self.render();
    }, 4000);
  };

  GiftBuilder.prototype.updateCard = function () {
    var to = this.el.to ? this.el.to.value.trim() : '';
    var from = this.el.from ? this.el.from.value.trim() : '';
    var msg = this.el.msg ? this.el.msg.value.trim() : '';

    if (this.el.prevTo) this.el.prevTo.textContent = to ? 'Sevgili ' + to + ',' : 'Sevgili …';
    if (this.el.prevMsg) {
      this.el.prevMsg.textContent = msg || 'Notunu buraya yaz — kartına el yazısıyla geçiyoruz.';
    }
    if (this.el.prevFrom) this.el.prevFrom.textContent = from ? from : '…';
    if (this.el.msgCount && this.el.msg) {
      this.el.msgCount.textContent = this.el.msg.value.length + ' / 240';
    }
  };

  /* --- Çizim --------------------------------------------------------------- */

  GiftBuilder.prototype.renderTabs = function () {
    var container = this.el.boxTabs;
    if (!container) return;

    var many = this.state.mode === 'each' && this.liveCount() > 1;
    container.hidden = !many;
    if (this.el.copyPrev) this.el.copyPrev.hidden = !many || this.state.active < 1;
    if (this.el.cardFor) {
      this.el.cardFor.hidden = !many;
      if (many) {
        this.el.cardFor.textContent =
          'Şu an ' +
          (this.state.active + 1) +
          '. kutunun kartını yazıyorsun. “Kime” ve kart notu bu kutuya özel; ' +
          'kimden, kurdele ve tarih tüm kutularda ortak.';
      }
    }
    if (!many) {
      container.innerHTML = '';
      return;
    }

    var html = '';
    for (var i = 0; i < this.liveCount(); i++) {
      var box = this.boxes[i];
      var n = this.boxItems(box);
      var limit = this.limit();
      var ready = this.boxReady(box);
      var name = (box.to || '').trim();
      html +=
        '<button type="button" role="tab" class="gb-boxtab' +
        (i === this.state.active ? ' is-current' : '') +
        (ready ? ' is-ready' : '') +
        '" data-gb-box="' +
        i +
        '" aria-selected="' +
        (i === this.state.active ? 'true' : 'false') +
        '"><span class="gb-boxtab__name">' +
        (name ? esc(name) : 'Kutu ' + (i + 1)) +
        '</span><span class="gb-boxtab__meta">' +
        (limit ? n + ' / ' + limit + ' ürün' : n + ' ürün') +
        '</span></button>';
    }
    container.innerHTML = html;
  };

  GiftBuilder.prototype.render = function () {
    var self = this;
    this.ensureBoxes();

    var box = this.current();
    var count = this.boxItems(box);
    var limit = this.limit();
    var subtotal = this.boxSubtotal(box);
    var boxCount = Math.max(1, this.state.boxCount);
    var each = this.state.mode === 'each' && boxCount > 1;
    var total = this.grandTotal();

    // Mod sorusu yalnızca birden fazla kutu istendiğinde anlamlı
    if (this.el.modeRow) this.el.modeRow.hidden = boxCount < 2;
    if (this.el.corpHint) this.el.corpHint.hidden = boxCount < 10;

    // Ürün kartları
    this.el.items.forEach(function (item) {
      var picked = box.sel.get(item.dataset.variant);
      var stepper = item.querySelector('[data-gb-stepper]');
      var add = item.querySelector('[data-gb-add]');
      var qty = item.querySelector('[data-gb-qty]');
      var badge = item.querySelector('[data-gb-count]');

      item.classList.toggle('is-picked', !!picked);
      if (stepper) stepper.hidden = !picked;
      if (add) add.hidden = !!picked;
      if (qty && picked) qty.textContent = picked.qty;
      if (badge && picked) badge.textContent = picked.qty;
    });

    // Kutu yuvaları
    if (this.el.slots) {
      var slotCount = limit || Math.max(count, 3);
      var thumbs = [];
      box.sel.forEach(function (item) {
        for (var i = 0; i < item.qty; i++) thumbs.push(item.img || '');
      });

      var length = Math.max(slotCount, thumbs.length);
      var previous = this.slotSignature || [];
      var changed = length !== previous.length;
      for (var s = 0; s < length; s++) {
        if ((thumbs[s] || '') !== (previous[s] || '')) changed = true;
      }

      if (changed) {
        var html = '';
        for (var i = 0; i < length; i++) {
          var thumb = thumbs[i];
          if (thumb === undefined) {
            html += '<div class="gb-slot"></div>';
          } else {
            // Yalnızca değişen yuva animasyonlanır, yoksa her güncellemede titrer.
            var isNew = (previous[i] || '') !== thumb;
            html +=
              '<div class="gb-slot gb-slot--filled' +
              (isNew ? ' gb-slot--new' : '') +
              '">' +
              (thumb ? '<img src="' + thumb + '" alt="" loading="lazy" width="120" height="120">' : '') +
              '</div>';
          }
        }
        this.el.slots.innerHTML = html;
        this.slotSignature = thumbs.slice(0, length);
      }
    }

    // Özet satırları
    if (this.el.lines) {
      if (!count) {
        this.el.lines.innerHTML = '<li class="gb-summary__line"><span>Kutun henüz boş.</span></li>';
      } else {
        var lines = '';
        box.sel.forEach(function (item, id) {
          lines +=
            '<li class="gb-summary__line"><span style="color:inherit;flex:1 1 auto"><b>' +
            item.qty +
            '×</b>' +
            esc(item.title) +
            (item.variantTitle ? ' — ' + esc(item.variantTitle) : '') +
            '</span><span>' +
            self.money(item.price * item.qty) +
            '</span><button type="button" class="gb-summary__remove" data-gb-remove="' +
            esc(id) +
            '" aria-label="Kutudan çıkar">×</button></li>';
        });
        this.el.lines.innerHTML = lines;
      }
    }

    var boxLabel = each ? (this.state.active + 1) + '. kutu · ' : '';
    if (this.el.countLabel) {
      this.el.countLabel.textContent =
        boxLabel + (limit ? count + ' / ' + limit + ' ürün' : count + ' ürün');
    }
    if (this.el.subtotalLabel) {
      this.el.subtotalLabel.textContent = each ? 'Bu kutu' : 'Ürünler';
    }
    if (this.el.subtotal) this.el.subtotal.textContent = this.money(subtotal);
    if (this.el.total) this.el.total.textContent = this.money(total);
    if (this.el.boxesRow) this.el.boxesRow.hidden = boxCount <= 1;
    if (this.el.boxesCount) {
      this.el.boxesCount.textContent = each
        ? boxCount + ' farklı kutu'
        : boxCount + ' kutu (aynı içerik)';
    }

    // Durum notu ve buton
    var note = '';
    var ready = this.allReady();
    if (each) {
      var missing = 0;
      var firstMissing = 0;
      for (var b = 0; b < this.liveCount(); b++) {
        if (!this.boxReady(this.boxes[b])) {
          if (!missing) firstMissing = b + 1;
          missing++;
        }
      }
      if (missing) {
        note =
          missing === 1
            ? firstMissing + '. kutu henüz hazır değil.'
            : missing + ' kutu henüz hazır değil (ilki: ' + firstMissing + '. kutu).';
      } else {
        note = boxCount + ' kutu hazır. Her biri kendi kartıyla paketlenir.';
      }
    } else if (!count) {
      note = limit ? limit + ' ürün seç, kutunu birlikte kuralım.' : 'En az 2 ürün seç.';
    } else if (limit && count < limit) {
      note = 'Kutun ' + (limit - count) + ' ürün daha bekliyor.';
    } else if (!limit && count < 2) {
      note = 'En az 2 ürün seç.';
    } else {
      note = 'Kutun hazır. Hediye paketi ve kart ücretsiz.';
    }
    if (this.el.note) this.el.note.textContent = note;
    if (this.el.submit) {
      this.el.submit.disabled = !ready;
      this.el.submit.textContent = each ? boxCount + ' kutuyu sepete ekle' : 'Kutuyu sepete ekle';
    }

    if (this.el.barLabel) {
      this.el.barLabel.textContent =
        boxLabel + (limit ? count + ' / ' + limit + ' ürün' : count + ' ürün');
    }
    if (this.el.barTotal) this.el.barTotal.textContent = this.money(total);

    this.renderTabs();
    this.applyFilters();
  };

  /* --- Sepete ekleme ------------------------------------------------------- */

  GiftBuilder.prototype.restart = function () {
    this.boxes = [newBox()];
    this.state.active = 0;
    if (this.el.done) this.el.done.hidden = true;
    if (this.el.builder) this.el.builder.hidden = false;
    this.loadCard();
    this.goTo(1);
    this.render();
  };

  GiftBuilder.prototype.submit = function () {
    var self = this;
    this.saveCard();

    var base = boxCode();
    var each = this.state.mode === 'each' && this.state.boxCount > 1;
    var boxCount = Math.max(1, this.state.boxCount);
    var items = [];
    var attributes = {};

    function addBox(box, code, multiplier, recipient) {
      box.sel.forEach(function (item, id) {
        var properties = { 'Hediye Kutusu': code, _gift_box: code };
        if (recipient) properties['Kime'] = recipient;
        items.push({ id: Number(id), quantity: item.qty * multiplier, properties: properties });
      });
    }

    if (each) {
      attributes['Hediye kutuları ' + base] = boxCount + ' farklı kutu';
      for (var i = 0; i < boxCount; i++) {
        var box = this.boxes[i];
        var code = base + '/' + (i + 1);
        var recipient = (box.to || '').trim();
        addBox(box, code, 1, recipient);
        attributes['Kutu ' + code + ' — kime'] = recipient || (i + 1) + '. kutu';
        if ((box.msg || '').trim()) {
          attributes['Kutu ' + code + ' — kart notu'] = box.msg.trim().slice(0, 240);
        }
      }
    } else {
      var single = this.boxes[0];
      attributes['Hediye kutusu ' + base] = boxCount > 1 ? boxCount + ' adet aynı kutu' : 'Tek kutu';
      addBox(single, base, boxCount, '');
      if ((single.to || '').trim()) {
        attributes['Hediye kutusu ' + base + ' — kime'] = single.to.trim();
      }
      if ((single.msg || '').trim()) {
        attributes['Hediye kutusu ' + base + ' — kart notu'] = single.msg.trim().slice(0, 240);
      }
    }

    if (!items.length) return;

    if (this.state.occasion) attributes['Hediye ' + base + ' — vesile'] = this.state.occasion;
    if (this.state.ribbonName) attributes['Hediye ' + base + ' — kurdele'] = this.state.ribbonName;
    if (this.el.from && this.el.from.value.trim()) {
      attributes['Hediye ' + base + ' — kimden'] = this.el.from.value.trim();
    }
    if (this.el.date && this.el.date.value) {
      attributes['Hediye ' + base + ' — teslim tarihi'] = this.el.date.value;
    }

    var label = this.el.submit.textContent;
    this.el.submit.disabled = true;
    this.el.submit.textContent = 'Sepete ekleniyor…';
    if (this.el.error) this.el.error.hidden = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .catch(function () {
        return { items: [], attributes: {} };
      })
      .then(function (cart) {
        var stale = staleAttributes(cart, base);
        Object.keys(stale).forEach(function (key) {
          if (!(key in attributes)) attributes[key] = '';
        });
        return fetch(self.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .then(function () {
        self.success(base, each ? boxCount : 0);
      })
      .catch(function () {
        self.el.submit.disabled = false;
        self.el.submit.textContent = label;
        if (self.el.error) {
          self.el.error.hidden = false;
          self.el.error.textContent =
            'Kutu sepete eklenemedi. Bir ürünün stoğu tükenmiş olabilir; seçimini gözden geçirip tekrar dene.';
        }
      });
  };

  GiftBuilder.prototype.success = function (code, eachCount) {
    var self = this;
    if (this.el.builder) this.el.builder.hidden = true;
    if (this.el.done) {
      this.el.done.hidden = false;
      var codeEl = this.el.done.querySelector('[data-gb-code]');
      if (codeEl) codeEl.textContent = eachCount ? code + '/1…' + eachCount : code;
      var headEl = this.el.done.querySelector('[data-gb-done-head]');
      if (headEl) headEl.textContent = eachCount ? eachCount + ' kutu sepette' : 'Kutun sepette';
    }
    if (this.el.side) this.el.side.classList.remove('is-open');

    this.el.submit.disabled = false;
    this.boxes = [newBox()];
    this.state.active = 0;
    this.loadCard();
    this.render();

    // Başlıktaki sepet sayacını tazele (tema desteği varsa).
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (node) {
          node.textContent = cart.item_count;
        });
        self.root.dispatchEvent(new CustomEvent('gift-box:added', { bubbles: true, detail: cart }));
      })
      .catch(function () {
        /* sepet sayacı tazelenemedi — kritik değil */
      });

    var top = this.root.getBoundingClientRect().top + window.pageYOffset - 20;
    window.scrollTo({ top: top, behavior: 'smooth' });
  };

  function init() {
    document.querySelectorAll('[data-gift-builder]').forEach(function (root) {
      if (root.dataset.gbReady) return;
      root.dataset.gbReady = 'true';
      new GiftBuilder(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Tema düzenleyicide bölüm yeniden yüklendiğinde
  document.addEventListener('shopify:section:load', init);
})();
